/**
 * Detect whether a VBuffer assetIndex entry already has a playable video `src`
 * (blob URL or HLS manifest), vs a capacity-policy black placeholder (`src: ''`).
 * Native hybrid progressive entries use empty `src` on purpose (Media3 underlay) — treat as live.
 */
export function assetIndexEntryHasLiveVideoSrc(entry: unknown): boolean {
  if (entry == null || typeof entry !== 'object') {
    return false
  }
  if ('isNativeVideo' in entry && (entry as { isNativeVideo?: unknown }).isNativeVideo === true) {
    return true
  }
  if (!('src' in entry)) {
    return false
  }
  const src = (entry as { src: unknown }).src
  return typeof src === 'string' && src.length > 0
}

/**
 * Remount when allow-video policy does not match the indexed entry shape
 * (placeholder ↔ real VideoContainer). Caller still remounts when `prevEntry` is missing.
 */
export function shouldRemountVideoForCapacityPolicy(
  prevEntry: unknown,
  allowVideo: boolean
): boolean {
  if (prevEntry == null) {
    return false
  }
  return allowVideo !== assetIndexEntryHasLiveVideoSrc(prevEntry)
}
